export default __webpack_public_path__ + "static/ensino-trilingue-336598bda14b9eba99f31301a0d3c1a4.svg";